type CheckCodeResponse = {
    correct: boolean;
    message: string;
};

export class NpcService {
    public async checkCode(code: string): Promise<CheckCodeResponse> {
        const response: Response = await fetch(`${VITE_API_URL}berdj/check-code/${code}`);
        const data: CheckCodeResponse = await response.json() as CheckCodeResponse;
        return data;
    }
}
